///<reference path="blog/right-panel/right-panel.component.ts"/>
import {BrowserModule, Title} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {AppRoutingModule} from './app-routing.module';
import {AboutComponent} from './about/about.component';
import {AuthorComponent} from './author/author.component';
import {ContactComponent} from './contact/contact.component';
import {BlogComponent} from './blog/blog.component';
import {MediaComponent} from './media/media.component';
import {RightPanelComponent} from './blog/right-panel/right-panel.component';
import {BlogDetailsComponent} from './blog/blog-details/blog-details.component';
import {SocialPanelComponent} from './blog/social-panel/social-panel.component';
import {BlogCommentComponent} from './blog/blog-comment/blog-comment.component';
import {QuoteComponent} from './quote/quote.component';
import {BooksComponent} from './books/books.component';
import {HttpService} from './services/http.service';
import {Ng2LoadingBarService} from './services/loading-bar-service';
import {Ng2LoadingBarComponent} from './loading-bar-component/loading-bar.component';
import {HttpModule} from '@angular/http';
import {HttpClientJsonpModule, HttpClientModule} from "@angular/common/http";
import {PaginationComponent} from "./blog/pagination/pagination.component";
import {FormsModule} from "@angular/forms";
import {Mod1Component} from './media/mod-1/mod-1.component';
import {Mod2Component} from './media/mod-2/mod-2.component';
import {Mod3Component} from './media/mod-3/mod-3.component';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        FooterComponent,
        AboutComponent,
        AuthorComponent,
        ContactComponent,
        BlogComponent,
        MediaComponent,
        RightPanelComponent,
        BlogDetailsComponent,
        SocialPanelComponent,
        BlogCommentComponent,
        QuoteComponent,
        BooksComponent,
        PaginationComponent,
        Ng2LoadingBarComponent,
        Mod1Component,
        Mod2Component,
        Mod3Component
    ],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        HttpClientJsonpModule
    ],
    providers: [
        HttpService,
        Ng2LoadingBarService,
        Title,
        RightPanelComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/app.module.ts